$('.choose-topic').click(function() {
    $('.topics-list').toggle('fast', function() {
        // Animation complete.
    });
    return false;
});

$(function($) {
    let url = window.location.href;
    $('li.topic-name a').each(function() {
        if (this.href === url) {
            $(this)
                .closest('li')
                .addClass('current-cat');
        }
    });
});
